<template>
  <v-expansion-panel expand class="elevation-0" v-model="expansion">
    <v-expansion-panel-content>
      <div slot="header">
        <v-icon class="mr-3">filter_list</v-icon>
        <span>Filter {{ title }}</span>
      </div>
      <v-card class="grey lighten-3" :height="height">
        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <slot scope="filterContent"></slot>
          </v-container>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  watch: {
    expansion: function() {
      if (this.expansion[0]) {
        this.openExpansion();
      }
    }
  },
  props: {
    title: String,
    height: String
  },
  data() {
    return {
      expansion: 1
    };
  },
  methods: {
    openExpansion() {
      this.$emit("openFilterExpansion");
    }
  }
};
</script>

<style>
</style>
